<template>
  <v-container class="fill-height pa-0 align-stretch" >

<!-- pwa front screen new -->
    <v-card :loading="loading" class="d-flex flex-column w-100" elevation=0 :img="backImg" v-if="(isloaded && isUsed && !isAgent && !isReported) || (isloaded && isUsed && isAgent && !isReported && isSameUser)" tile>

     <div class="fill-height d-flex flex-column w-100" style="background:rgba(0,0,0,0.4)">

      <div class="mb-auto pt-5" >
        <h1 class="text-center white--text col-12 pb-0 font-weight-light display-1">WELCOME</h1>
        <div v-if="(tagBusiness.welcomemsg!='null' && tagBusiness.welcomemsg!=null)">
          <p class="text-center white--text col-12"  v-html="tagBusiness.welcomemsg"></p>
        </div>
      </div>



      <v-card-text>
        <h2 class="white--text col-12 text-center pb-0 headline font-weight-bold" v-if="tagBusiness.businessName">{{tagBusiness.businessName}}</h2>
        <p class="white--text col-12 text-center" v-if="tagBusiness.addressLine3!='null' ||tagBusiness.addressLine4!='null'"> {{tagBusiness.addressLine3}} {{tagBusiness.addressLine4}} </p>


        <p class="col-12 text-center">
        <v-btn dark class="white-text font-weight-regular text-transform-uppercase" color="rgba(255,255,255,0.3)" rounded="true" @click="businessExplore()">Discover <v-icon class="ml-3">mdi-arrow-right</v-icon> </v-btn></p>

      </v-card-text>


      <div class="mt-auto pb-2">
                          <div class="white--text text-center col-12 pb-0 " style="font-size: 0.625rem !important;">POWERED BY</div>
                          <div class=" text-center pb-0 pt-0 col-12"><img :src="juzzapLogo"  height="30"/></div>
      </div>
      </div>

    </v-card>
<!--End pwa front screen new -->

    <!-- Tag is not Assign and Assign to business -->
    <v-card class="w-100 test" v-if="isloaded && !isUsed && !isSaved && (isAgent || isBusinessUser)" :loading="loading">
        <v-card-text v-if="isAgent || isBusiness">
          <!-- <v-img :src="logoImage" aspect-ratio="1" class="lighten-2" height="60" width="121"></v-img> -->

          <div class="" style="text-align:center;">
            <!-- <v-img :src="logoImage" aspect-ratio="1" class="lighten-2" height="60" width="121"></v-img> -->
            <img :src="logoImage" />
          </div>

          <v-row >
            <v-col cols="12" md="12" align="center" justify="center">
              <v-img :src="excelgem" aspect-ratio="1" class="lighten-2" height="75" width="75" @click="submit"></v-img>
            </v-col>
          </v-row>

          <v-form v-model="valid" id="assignTag">
            <v-row v-if="isBusiness">
              <v-col cols="12" md="12" class="text-center">
                <h2>{{$t('zz_tag_current_business_is')}}</h2><br>
                <div class="busname py-1">
                  <span >{{storeBusiness.businessName}}</span>
                </div>
              </v-col>
              <v-col cols="12" md="12" v-if="isAgent">OR</v-col>
            </v-row>
            <v-row v-if="isAgent">
              <v-col cols="12" md="12"><h2>{{$t('zz_tag_current_business_is')}}</h2></v-col>
            </v-row>
            <v-row v-if="isAgent">
                        <v-col cols="12" md="12">
                          <v-autocomplete
                            :loading="loading"
                            label="Businesses"
                            item-value="id"
                            item-text="businessName"
                            :items="businesses"
                            name="business_id"
                            v-model="business_id"
                            :search-input.sync="search"
                          ></v-autocomplete>
                        </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" md="6">
                <v-select v-model="public" item-text="name" item-value="value" :items="publics" :label="$t('zz_tag_public')"></v-select>
              </v-col>
              <v-col cols="6" md="6">
                <v-autocomplete
                :label="$t('zz_tag_location')"
                v-model="taglocation_id"
                name="taglocation_id"
                item-text="name"
                item-value="id"
                :items="taglocations"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" md="6">
                <v-text-field
                v-model="refno"
                name="refno"
                :label="$t('zz_tag_ref_no')"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6">
                <v-text-field
                v-model="capacity"
                name="capacity"
                :label="$t('zz_tag_capacity')"
                placeholder="Table of 4, Double Bedroom..."
                ></v-text-field>
              </v-col>
            </v-row>


            <v-row>
              <v-col cols="12" md="12"><h2>{{$t('zz_tag_notes')}}</h2></v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">


                <v-text-field
                v-model="remark"
                :label="$t('zz_tag_notes')"
                name="Remark"
                :placeholder="$t('zz_tag_notes_placeholder')"
                >
                </v-text-field>

              </v-col>
            </v-row>
            <v-row class="help">
              <v-col cols="6" md="6">
                <div class="my-3">
                  <v-btn style="color:white" @click="submit" class="btn">{{$t('zz_tag_confirm')}}</v-btn>
                </div>
            </v-col>
            <v-col cols="6" md="6">
            <div class="ma-0 pa-0 text-right">
              <v-dialog
              v-model="dialog"
              width="800"
              v-bind="attrs"
              v-on="on">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      elevation="2"
                      color="#FE5800"
                      fab
                      v-bind="attrs"
                      v-on="on">
                      <v-icon color="white">mdi-information-variant</v-icon>
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title class="section-spread text-h1 zzorganebg">
                      <h1 class="font-weight-bold display-1 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-help-rhombus-outline</v-icon>{{$t('zz_tag_assign_explainer_title')}}</h1>
                    </v-card-title>
                    <p class="pt-5 px-4">
                      <span v-html="$t('zz_tag_assign_explainer1')"></span>
                    </p><br>
                    <v-divider></v-divider>
                    <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                </v-card>
              </v-dialog>
            </div>
          </v-col>

            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                          <h4 v-html="$t('zz_tag_confirm_text')"></h4> {{this.storeBusiness.businessName}}</h4>

              </v-col>

            </v-row>

            <div class="my-3">
                        <v-btn style="color:white" @click="cancel" class="btn">CANCEL</v-btn>
            </div>

            <!-- <v-row>
                        <v-col cols="12" md="12">
                          <h4 class="subtitle-1">TERMS & CONDITIONS APPLY</h4>
                        </v-col>
            </v-row> -->
          </v-form>
        </v-card-text>
    </v-card>

<!-- Tag is Assign Confirm Message  -->
    <v-card class="w-100" v-if="isloaded && isSaved"  :loading="loading">
      <v-card-text>
        <!-- <v-img :src="logoImage" aspect-ratio="1" class="lighten-2" height="60" width="121"></v-img> -->
        <div class="" style="text-align:center;">
            <img :src="logoImage" />
        </div>
        <v-row >
            <v-col cols="12" md="12" align="center" justify="center">
              <v-img :src="confirmImage" aspect-ratio="1" class="lighten-2" height="100" width="100"></v-img>
            </v-col>
        </v-row>

        <v-row >
            <v-col cols="12" md="12" align="center" justify="center" class="txt_color">
                          [{{this.storeBusiness.businessName}}]
            </v-col>
        </v-row>

        <v-row >
            <v-col cols="12" md="12" align="center" justify="center" class="headline">
              <h1>CONFIRMED!</h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="12" class="title" align="center" justify="center">
              To Add Another
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="12" class="title" align="center" justify="center">
                        JUST ZAP IT!
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="12" class="title" align="center" justify="center">

             <v-btn color="btn" @click="exit">VIEW juZZap</v-btn>

            </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12" class="" align="center" justify="center">
            TERMS & CONDITIONS APPLY
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>

<!-- Tag is Already Assign   -->
    <v-card v-if="isloaded && (isUsed && isAgent && !isSameUser) && !isReported" class="elevation-12 ">
      <v-card-text >
        <div class="" style="text-align:center;">
          <!-- <v-img :src="logoImage" aspect-ratio="1" class="lighten-2" height="60" width="121"></v-img> -->
          <img :src="logoImage" />
        </div>
        <v-row >
          <v-col cols="12" md="12" align="center" justify="center">
             <v-img :src="asImage" aspect-ratio="1" class="lighten-2" height="100" width="100"></v-img>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="12" md="12" align="center" justify="center">
                        <!-- <p class="title">SORRY,<br>This Tag Has Already Been Assigned To.</p> -->

            <p class="title">SORRY,<br>This Tag is locked as it has already been assigned to.</p>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="12" md="12" align="center" justify="center">
            <p class="title txt_color">{{bName}}</p>
            <p class="title txt_color">{{bType}}</p>
            <p class="title txt_color"> {{bAddress}}</p>
                        <!-- <p class="title txt_color">REGISTERED BY {{agentname}} on {{bAssignDate}}</p> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" align="center" justify="center" class="title">
            Contact Agent
          </v-col>
          <v-col cols="12" md="12" align="center" justify="center" class="title txt_color" >
            <router-link to="/agent/dashboard">{{agentname}}</router-link>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="12" md="12" align="center" justify="center">
            <router-link to="/agent/dashboard">
              <v-btn class="btn">HOME PAGE</v-btn>
            </router-link>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="12" md="12" align="center" justify="center" class="org-clr">
           <p>if you have found this tag and believe it has been lost please let us know and we will find it's owner.</p>
           <p>Thank You</p>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="12" md="12" align="center" justify="center">
            <v-btn class="btn" @click="report()">REPORT IT</v-btn>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="12" md="12" align="center" justify="center">
            <p class="">TERMS & CONDITIONS APPLY.</p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

<!-- Tag is Already Assign  not Assign Yet -->
    <v-card v-if="isloaded && !isUsed && !isAgent && !isSaved && !isBusiness" class="elevation-12 ">
      <v-card-text >
        <!-- <v-img :src="logoImage" aspect-ratio="1" class="lighten-2" height="60" width="121"></v-img> -->
        <div class="" style="text-align:center;">
          <img :src="logoImage" />
        </div>
          <v-row v-if="!isReported">
            <v-col cols="12" md="12" align="center" justify="center">
                        <v-img :src="questiongem" aspect-ratio="1" class="lighten-2" height="75" width="75"></v-img>
            </v-col>
          </v-row>
          <v-row v-if="!isReported">
            <v-col cols="12" md="12" align="center" justify="center">
              <span v-html="$t('zz_tag_sorry_not_assigned')"></span>
              <!-- <p class="title">Oh SORRY,<br> THIS TAG HAS NOT BEEN ASSIGNED YET.</p> -->
            </v-col>
          </v-row>
          <div class="ma-0 pa-0 text-center">
              <v-dialog
              v-model="dialog"
              width="800"
              v-bind="attrs"
              v-on="on">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      elevation="2"
                      color="#FE5800"
                      fab
                      v-bind="attrs"
                      v-on="on">
                      <v-icon color="white">mdi-information-variant</v-icon>
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title class="section-spread text-h1 zzorganebg">
                      <h1 class="font-weight-bold display-1 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-help-rhombus-outline</v-icon>{{$t('zz_tag_assign_troubleshooting_title')}}</h1>
                    </v-card-title>
                    <p class="pt-5 px-4">
                      <span v-html="$t('zz_tag_assign_explainer2')"></span>
                    </p><br>
                    <v-divider></v-divider>
                    <!-- <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br> -->
                </v-card>
              </v-dialog>
            </div>



          <v-row v-if="!isReported">
            <v-col cols="12" md="12" align="center" justify="center">
              <span v-html="$t('zz_tag_found')"></span>
            </v-col>
          </v-row>
          <v-row v-if="!isReported">
            <v-col cols="12" md="12" align="center" justify="center">
              <v-btn class="btn" style="color:white">juZZap.com</v-btn>
            </v-col>
          </v-row>

          <!-- <v-row v-if="!isReported">
                      <v-col cols="12" md="12" align="center" justify="center">
                        <v-btn class="btn" @click="report()">REPORT IT</v-btn>
                      </v-col>
          </v-row> -->
      </v-card-text>
    </v-card>

<!-- REPORT IT -->
    <v-card class="elevation-12" v-if="isReported">
      <v-card-text>
        <v-img :src="logoImage" aspect-ratio="1" class="lighten-2" height="60" width="121"></v-img>
          <v-row>
                    <v-col cols="12" md="12" xs="12" sm="12">
                      <v-form id="reportTag" >
                        <v-row>
                          <v-col cols="12" md="12" xs="12" sm="12" align="center" justify="center">
                            <v-select v-model="reporttype" item-text="name" item-value="value" :items="reportTypes" label="Please tell us about this Tag..." name="reporttype"></v-select>
                          </v-col>
                          <v-col cols="12" md="12" xs="12" sm="12" align="center" justify="center">
                            <v-text-field
                              v-model="name"
                              name="name"
                              label="Name"
                              type="text"
                              required
                              v-validate="'required|max:255'"
                              :error-messages="errors.collect('name')"
                              data-vv-name="name"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="12" xs=12 align="center" justify="center">
                            <v-text-field
                              v-model="email"
                              name="email"
                              label="Email"
                              type="email"
                              required
                              v-validate="'required|email'"
                              :error-messages="errors.collect('email')"
                              data-vv-name="email"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" md="12" xs=12 align="center" justify="center">
                            <v-text-field v-model="phone" name="phone" label="Phone" type="tel"></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" md="12" xs=12 align="center" justify="center">
                            <v-textarea v-model="message" name="message" label="Message"></v-textarea>
                          </v-col>
                        </v-row>

                        <v-divider></v-divider>
                        <div class="my-3">
                          <v-btn color="btn" @click="reportsubmit">Create Report</v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
      </v-card-text>
    </v-card>



  </v-container>
</template>

<script>
import Vue from 'vue'
import moment from 'moment';
export default {
    props: {
    source: String
  },
  data: () => ({
      //juzzapLogo:require('@/assets/juzzap-logo.svg'),
      juzzapLogo:require('@/assets/juzzap-logo.svg'),
      //backImg:require('@/assets/Splashscreen.png'),
      backImg:'',
      //backImg:require('@/assets/back.jpg'),
      confirmImage:require('@/assets/confirm.png'),
      excelgem:require("@/assets/tags/exclimation-gem.svg"),
      questiongem: require("@/assets/tags/question-gem.svg"),
      fbimg:require("@/assets/fb.png"),
      tripadvisorimg:require("@/assets/tripadvisor.png"),
      googlemapimg:require("@/assets/googlemap.png"),
      logoImage: require("@/assets/JUZZAPLOGO.png"),
      asImage:require("@/assets/assign.png"),
      loading:false,
      search: null,
      valid: true,
      isAgent: false,
      isBusiness:false,
      isSameUser:false,
      business_id: "",
      businesses: [],
      storeBusiness: [],
      tagBusiness: {},
      isReported: false,
      isloaded:false,
      isNotLogin: false,
      isSaved: false,
      valid: true,
      isBusiness: false,
      isUsed: false, //Tag not assign any bussiness
      code: "",
      business_id: "",
      businesses: [],
      storeBusiness: [],
      tagBusiness: {},
      components: [
        "Autocompletes",
        "Comboboxes",
        "Forms",
        "Inputs",
        "Overflow Buttons",
        "Selects",
        "Selection Controls",
        "Sliders",
        "Textareas",
        "Text Fields"
      ],
      reportTypes: [
        { name: "Found on street", value: "Found on street" },
        { name: "Found stuck in a public place", value: "Found stuck in a public place" },
        { name: "Found in wrong buisness", value: "Found in wrong buisness" },
        { name: "Damaged Tag", value: "Damaged Tag" },
        { name: "Request a replacement - damaged", value: "Request a replacement - damaged" },
      ],
      socialmedias:[],
      events:[],
      remark:'',
      storeRemark:'',
      publics: [{name:"Yes",value:"1"}, {name:"No",value:"0"}],
      capacity:0,
      refno:'',
      taglocation_id:0,
      public:0,
      taglocations:[],
      businessName:"",
      storeBusiness:[],
      isBusinessUser:false,

  }),
  created()
  {
    if (this.$route.params.code)
    {
        this.code = this.$route.params.code;
        this.checkTags();
       // this.fetchTagLocation();

    }
    if(localStorage.getItem('business'))
    {
    this.storeBusiness=JSON.parse(localStorage.getItem('business'));
    }

  },
  methods:
  {
    fetchTagLocation()
    {
      this.$http
      .get(this.$apidomain+"taglocationlist")
      .then(res => {
      this.taglocations = res.data.taglocation;
      //console.log("types "+ this.types);
      })
      .catch(err => {
      console.log(err.response);
      });

    },
    exit()
    {

      this.$router.push({name:'food',params:{tag:  this.code,key:this.getCookie('jzuserkey')}});


    },

    report() {
      this.isReported = true;
    },
    getEvents(businessid)
    {
       this.$http
      .get(this.$apidomain+"eventList/"+businessid)
      .then(res => {
       this.events = res.data.events;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    getBusiness(agentid) {
      this.$http
        //.get(this.$apidomain+"agent/businessbyagent/"+agentid)
        .get(this.$apidomain+"agent/businesslistnew")
        .then(res => {
          this.businesses =res.data.businesses;
          this.backImg=res.data.businesses.backgroundimage;
          if(this.backImg==null)
          {
            this.backImg=require('@/assets/Splashscreen.png');
          }

          //this.business_id=this.businesses.id;
          //console.log(this.businesses);
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    submit() {
      let th = this;

      if (this.$validator.validateAll()) {
        let fd = new FormData(document.getElementById("assignTag"));

        if(this.isBusinessUser)
        {
          fd.append("agent_id", '128');
        }

        fd.append("unique_tag", this.code);

        if(this.isAgent)
        {
          fd.append("business_id", this.business_id);
        }else if(this.isBusinessUser){
          fd.append("business_id", this.storeBusiness.id);
        }
        //fd.append("remark", this.remark);

        let submiturl="";

        if(this.isAgent)
        {
          submiturl=this.$apidomain+"agent/businesstagsubmit";

        }
        else if(this.isBusinessUser){
          submiturl=this.$apidomain+"businesstagsubmit";

        }

        fd.append('taglocation_id',this.taglocation_id);
        fd.append('public',this.public);
        this.$http
          .post(
            submiturl,
            fd
          )
          .then(res => {
            if (res.data.success) {
              //alert("Save");
              this.isSaved = true;
              this.isUsed = false;
              this.isBusiness = false;
              this.isAgent = false;
              this.isBusiness=false;
              this.storeBusiness = res.data.business;
              this.storeRemark=res.data.businessTag.remark;
              console.log("Saved ");
              this.$store
                .dispatch("assignBusiness", JSON.stringify(this.storeBusiness))
                .then(() => {});

              this.$store.dispatch("assignRemark",this.storeRemark).then(()=>{})  ;
            } else {
              let errmsg = [];
              for (var prop in res.data.errors) {
                errmsg.push(res.data.errors[prop][0]);
              }
              alert(errmsg[0]);
            }
          })
          .catch(err => {
            console.log("Error " + err.response);
          });
      }
    },
    cancel()
    {
        this.$router.push('/agent/dashboard');

    },
    getCookie(cname)
    {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    },
    checkTags()
    {
      this.$http
        .get(this.$apidomain+"checktag/" + this.code)
        .then(res => {
          if (res.data.success == 0)
          {

            this.isUsed = false;
            let user = JSON.parse(localStorage.getItem("user") || "{}");
            let agent_id = "";



            if (Object.keys(user).length !== 0)
            {
              if(user.userType=="business")
              {
                this.isBusinessUser=true;

                this.isBusiness=true;
                this.fetchTagLocation();
              }
              if (user.userType == "agent")
              {
                this.isAgent = true;

                agent_id = user.id;

                 let cBusiness = JSON.parse(localStorage.getItem("business") || "{}");

                 if (Object.keys(cBusiness).length !== 0) {

                   this.storeBusiness = JSON.parse(
                     localStorage.getItem("business")
                   );
                  this.isBusiness = true;
                  this.business_id = this.storeBusiness.id;
                  this.remark=localStorage.getItem("remark");
                 }

                this.getBusiness(agent_id);
                this.fetchTagLocation();
              }
              this.isNotLogin = false;
            } else {
              this.isNotLogin = true;
            }
          }
          else
          {
            //alert("This tag allready in used.");
            this.isUsed = true;
            let user = JSON.parse(localStorage.getItem("user") || "{}");
            let business=JSON.parse(localStorage.getItem("business") || "{}");

            let agent_id = "";


            if (Object.keys(user).length !== 0)
            {

              if (user.userType == "agent") {
                this.isAgent = true;
                agent_id = user.id;
                if(business.creater_id==agent_id)
                {
                  console.log("conditino");
                  this.isSameUser=true;
                  console.log('same user '+ this.isSameUser);
                }
                this.getBusiness(agent_id);
              }

              if (user.userType == "user") {
              }

            }
            else //for update zaped
            {
                console.log('check user not login');
                this.$http.post('https://api.juzzap.com/api/updatezaped/'+ this.code)
                .then(res=>{

                })
                .catch(err=>{
                console.log(err.response);
                });

                this.$http.post('https://api.juzzap.com/api/inserttaganalitics/'+ this.code+'/nfc')
                .then(res=>{

                })
                .catch(err=>{
                console.log(err.response);
                });
            }

            this.socialmedias=res.data.socialmedia;
            this.tagBusiness = res.data.business;

            this.backImg=this.tagBusiness.backgroundimage;
            if(this.backImg==null)
            {
              this.backImg=require('@/assets/Splashscreen.png');
            }


            this.bName=res.data.business.businessName;
            this.bType=res.data.business.businessType;
            this.business_id=res.data.business.id;



            if(res.data.business.addressLine1!=null){
               this.bAddress=res.data.business.addressLine1+' ';
            }
            if(res.data.business.addressLine2!=null){
               this.bAddress=res.data.business.addressLine2+' ';
            }
            if(res.data.business.addressLine3!=null){
               this.bAddress=res.data.business.addressLine3+' ';
            }
            if(res.data.business.addressLine4!=null){
               this.bAddress=res.data.business.addressLine4+' ';
            }


            this.bAssignDate=moment(String(res.data.business.created_at)).format('DD/MM/YYYY');
            //this.agentname=res.data.agent.name;
            this.agentname=res.data.agent.firstName;
            console.log("isUsed "+ this.isUsed);
            console.log("Tag Business " + this.tagBusiness.id);
            console.log("Business Name " );

            this.getEvents(this.tagBusiness.id);

          }
          // alert(res.data.success);
          //this.data=res.data.BusinessTag;
          this.isloaded=true;

          if((this.isloaded && this.isUsed && !this.isAgent && !this.isReported) || (this.isloaded && this.isUsed && this.isAgent && !this.isReported && this.isSameUser))
          {

            //this.$router.push({name:'businessDetails',params:{id:  this.business_id}});

           //this.$router.push({name:'bDetails',params:{tag:  this.code,key:this.getCookie('jzuserkey')}});
            //this.$router.push({name:'blogin',params:{code:  this.code}});

            //this.$router.push({name:'businesshome',params:{code: this.code,key:this.getCookie('jzuserkey')}});

           this.$router.push({name:'food',params:{tag:  this.code,key:this.getCookie('jzuserkey')}});

          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    businessExplore()
    {
      this.$router.push({name:'businessDetails',params:{id:  this.business_id}});
    },
    reportsubmit()
    {
       let th = this;
        if (this.$validator.validateAll())
        {
           let fd = new FormData(document.getElementById("reportTag"));
           fd.append('code',this.code);
           fd.append('msg',this.message);
           fd.append('reporttype',this.reporttype);
           this.$http.post('https://api.juzzap.com/api/reporttag',fd)
        .then(res=>{
          if(res.data.success)
          {
           //console.log('Form data '+fd);
           this.$router.push('/thankyou/');
          }
           else
            {
                let errmsg=[];
                for(var prop in res.data.errors){
                    errmsg.push(res.data.errors[prop][0]);
                }
                //alert(errmsg[0]);
            }

        })
        .catch(err=>{
          console.log(err.response);
        });


        }
    },
  } ,

}
</script>
<style >
.b-name{

}
.v-application p
{
	margin-bottom: 0px !important;
}
.btn {
  background-color: #e9540d !important;
  color: #fff;
}
.org-clr{
  color: #e9540d !important;
}
.txt_color{
  color: #ff5800 !important;
}
.social:hover{
  cursor: pointer;
}


.ico
{
  width: 40px;
  height: 40px;
  display: inline-flex;
  background: #ED5800;
  line-height: 40px;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 4px;

}
.fs-30
{
  font-size: 30px;
}

.ico-60
{
  width: 60px;
  height: 60px;
  line-height: 60px;
}
.ico-80
{
  width: 80px;
  height: 80px;
  line-height: 80px;
}
.fs-45
{
  font-size: 45px;
}
.fs-60
{
  font-size: 60px;
}
.rotate-45 {
  filter: progid: DXImageTransform.Microsoft.BasicImage(rotation=0.5);
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            -o-transform: rotate(45deg);
            transform: rotate(45deg);
        }

        .rotate-45-rev {
            filter: progid: DXImageTransform.Microsoft.BasicImage(rotation=-0.5);
            -webkit-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            transform: rotate(-45deg);
        }
        .mt-60{
            margin-top: 60px;
        }
        .mb-60{
            margin-bottom: 60px;
        }
       .v-application a
       {
        color: #ED5800;
      }
      .fs-10{
        font-size: 10px !important;
      }

      .busname{
        font-size: 30px;
        font-weight: 800;
        color: #EF5800;
        border: 5px solid #ED5800;
      }
      .help{
        align-items: center;
        justify-content: space-between;
      }

</style>
